export default __webpack_public_path__ + "static/media/gp-green-arrow.b7975964.svg";